<template>
  <div class="last-news-container">
    <custom-router-link :item="info" class="last-news-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <div class="news-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img2.png')" fit="cover" v-else></el-image>
      </div>
      <div class="news-details">
        <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
        <div class="news-title">{{info.name}}</div>
        <div class="news-summary">{{info.summary}}</div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.last-news-container {
  width: 100%;
  height: 172px;
  .last-news-link {
    display: flex;
    width: 100%;
    height: 100%;
    .news-image {
      width: 256px;
      height: 172px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .news-details {
      flex: 1;
      width: calc(100% - 16px - 256px);
      margin-left: 16px;
      .publish-time {
        color: #6c757d;
        font-size: 16px;
        margin: 8px 0;
      }
      .news-title {
        font-size: 20px;
        font-weight: 600;
        line-height: 32px;
        margin: 10px 0;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-summary {
        font-size: 14px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .last-news-container {
    height: auto;
    .last-news-link {
      flex-direction: column;
      .news-image {
        width: 100%;
        height: auto;
        aspect-ratio: 16/9;
        overflow: hidden;
      }
      .news-details {
        width: 100%;
        margin-left: 0;
        .publish-time {
          color: #6c757d;
          font-size: 12px;
          margin: 8px 0;
        }
        .news-title {
          font-size: 18px;
          line-height: normal;
          margin: 8px 0;
        }
      }
    }
  }
}
</style>